import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { fmtMin } from './ReportKpis';

const GROUPS = [['place', 'By place'], ['vehicle', 'By vehicle'], ['driver', 'By driver']];
const COLS = [
  ['load_trip', 'Loading', 'Ready → Start'],
  ['load_stop', 'At pickup stops', 'Arrived → Done'],
  ['unload_trip', 'Unloading', 'End → Complete'],
  ['unload_stop', 'At drop stops', 'Arrived → Done'],
];

const TimeCell = ({ st, testId }) => (st?.count
  ? <div data-testid={testId}><p className="font-semibold text-[#1A1F2E]">{fmtMin(st.avg_min)}</p>
      <p className="text-[11px] text-gray-500">max {fmtMin(st.max_min)} · {st.count}×</p></div>
  : <span className="text-gray-300" data-testid={testId}>—</span>);

export const LoadUnloadReport = ({ data, group, onGroup }) => {
  const rows = data?.[`by_${group}`] || [];
  const label = GROUPS.find(g => g[0] === group)?.[1].replace('By ', '') || 'place';
  return (
    <div data-testid="lu-report">
      <div className="flex flex-wrap items-center gap-2 mb-2 print:hidden">
        {GROUPS.map(([g, l]) => (
          <Button key={g} size="sm" variant={group === g ? 'default' : 'outline'} onClick={() => onGroup(g)}
            className={group === g ? 'bg-[#1A1F2E]' : ''} data-testid={`lu-group-${g}`}>{l}</Button>
        ))}
        <span className="text-xs text-gray-500 ml-2" data-testid="lu-trips-timed">From {data?.trips_timed ?? 0} completed trips with timings · average, longest and number of times</span>
      </div>
      <Card className="border-0 shadow-md"><CardContent className="p-0">
        <Table data-testid="lu-report-table">
          <TableHeader><TableRow>
            <TableHead className="capitalize">{label}</TableHead>
            {COLS.map(([k, t, s]) => <TableHead key={k}>{t}<span className="block text-[10px] font-normal text-gray-400">{s}</span></TableHead>)}
            <TableHead>Total time</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={`${r.key}-${i}`} data-testid={`lu-row-${i}`}>
                <TableCell className="font-medium" data-testid={`lu-name-${i}`}>{r.name}{r.sub && <span className="block text-[11px] text-gray-500">{r.sub}</span>}</TableCell>
                {COLS.map(([k]) => <TableCell key={k}><TimeCell st={r[k]} testId={`lu-${k}-${i}`} /></TableCell>)}
                <TableCell data-testid={`lu-total-${i}`}>{fmtMin(r.total_min)}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-gray-400 py-8" data-testid="lu-empty">No timed loading or unloading in this range.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
      <p className="text-[11px] text-gray-400 mt-2">Stops marked Done without Arrived, or closed automatically at End Trip, have no time and are left out.</p>
    </div>
  );
};
